import { site } from "./settings";

const services = [
  { text: "Przejdź do SOPAB", value: "https://sopab-pilotaz.gunb.gov.pl/" },
  {
    text: "Przejdź do eBudownictwo",
    value: "https://e-budownictwo.gunb.gov.pl/"
  },
  { text: "Przejdź do GUNB", value: "https://www.gov.pl/web/gunb/" },
  {
    text: "Przejdź do eBudownictwo Wnioski",
    value: "https://wnioski.gunb.gov.pl"
  },
  { text: "Przejdź do CEEB", value: "https://zone.gunb.gov.pl" },
  { text: "Przejdź do eCRUB", value: "https://e-crub.gunb.gov.pl" },
  {
    text: "Przejdź do eWykonania Zastępcze",
    value: "https://e-wykonaniazastepcze.gunb.gov.pl"
  },
  { text: "Przejdź do SNRWB", value: "https://snrwb.gunb.gov.pl/public/" },
  { text: "Przejdź do RWDZ", value: "https://wyszukiwarka.gunb.gov.pl" },
  { text: "Przejdź do Akademii", value: "https://akademia.gunb.gov.pl" }
];

export const serviceListEDB = [
  { text: "e-dziennikbudowy", value: "current" },
  { text: "Przejdź do cKOB", value: "https://c-kob.gunb.gov.pl" },
  ...services
];
export const serviceListCkob = [
  { text: "Książka obiektu budowlanego", value: "current" },
  { text: "Przejdź do EDB", value: "https://e-dziennikbudowy.gunb.gov.pl" },
  ...services
];

const serviceListBySite = {
  EDB: serviceListEDB,
  CKOB: serviceListCkob
};

export const servicesList = serviceListBySite[site];

// const base_url = window.location.origin;

export const instructions = [
  {
    text: "Instrukcja dla właściciela i zarządcy",
    link: "/files/c-KOB_Instrukcja_dla_wlasciciela_i_zarzadcy.pdf"
  },
  {
    text: "Instrukcja dla osoby prowadzącej książkę",
    link: "/files/c-KOB_Instrukcja_dla_osoby_prowadzacej_ksiazke.pdf"
  },
  {
    text: "Instrukcja dla osoby przeprowadzającej kontrole",
    link: "/files/c-KOB_Instrukcja_dla_osoby_przeprowadzajacej_kontrole.pdf"
  }
];

export function getYoutubeLink(url) {
  return `<iframe width="560" height="315" src=${url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
}

export const moviesSections = [
  {
    id: 1,
    section: "Podstawowe informacje <span class='nw'>o c-KOB</span>",
    moviesList: [
      {
        title: "Gdzie znaleźć <span class='nw'>c-KOB?</span>",
        url: "https://www.youtube.com/embed/sakMvkXusN4?si=CBtuWHSbHB8_7iVE"
      },
      {
        title: "Co znajduje się na stronie c-KOB?",
        url: "https://www.youtube.com/embed/GwJVi2_cY34?si=5ieBRcW0YoBLKxps"
      },
      {
        title: 'Dział "Dowiedz się więcej"',
        url: "https://www.youtube.com/embed/PZ1uD0nicQk?si=vHFUGbimjFWJ-2xs"
      }
    ]
  },
  {
    id: 2,
    section: "Logowanie do c-KOB",
    moviesList: [
      {
        title: "Jak się zalogować?",
        url: "https://www.youtube.com/embed/WE9DwvuepvI?si=HjYnX66ZNwi45Xcd"
      },
      {
        title: "Przyjęcie roli",
        url: "https://www.youtube.com/embed/gRQwsaJhees?si=nSPyLnin7grzxNRg"
      },
      {
        title: "Logowanie do Systemu jako pracownik administracji",
        url: "https://www.youtube.com/embed/PZ1uD0nicQk?si=KpbmEpoRlN-u5ddQ"
      }
    ]
  },
  {
    id: 3,
    section: "Zakładanie i praca w Książce krok po kroku",
    moviesList: [
      {
        title: "Co widzimy na ekranie c-KOB?",
        url: "https://www.youtube.com/embed/wxZ26j78YPA?si=rulOviry_dQtHDyI"
      },
      {
        title: "Jak założyć Książkę?",
        url: "https://www.youtube.com/embed/UO1Ak3lGPY4?si=3S7HVAz97t0CX76r"
      },
      {
        title: "Jak dodać wpisy do Książki?",
        url: "https://www.youtube.com/embed/gPZtiA8i1-A?si=8EWTN6Ezyn5gdJdf"
      },
      {
        title: "Kim są i jak dodawać interesariuszy Książki?",
        url: "https://www.youtube.com/embed/Ny0iLMorUuc?si=FnHkjbZndMcS7ZS_"
      }
    ]
  }
];

export const FAQ = [
  {
    title: "Dziennik budowy",
    items: [
      {
        question: "Kiedy jest wymagany dziennik budowy?",
        answer: `Prowadzenie dziennika budowy jest obowiązkiem kierownika budowy. 
      W&nbsp;związku z&nbsp;tym, obowiązek posiadania dziennika budowy dotyczy robót budowlanych, przy których wymagane jest ustanowienie kierownika budowy.`
      },
      {
        question: "Kiedy Inwestor powinien ustanowić kierownika budowy?",
        answer: `<p>Ustanowienie kierownika budowy jest wymagane w&nbsp;przypadku robót budowlanych objętych decyzją o&nbsp;pozwoleniu na budowę,
    rozbiórki objętej decyzją o&nbsp;pozwoleniu na rozbiórkę, robót budowlanych objętych
     decyzją o&nbsp;legalizacji budowy lub pozwoleniu na wznowienie robót budowlanych oraz w&nbsp;przypadku niektórych robót budowlanych wymagających zgłoszenia <span class='nobr'>(art. 42 ust. 1 pkt 2).</span></p>
     <p>W przypadku zwolnienia z&nbsp;obowiązku ustanowienia kierownika budowy, nie ma również obowiązku posiadania dziennika budowy.</p>`
      }
    ]
  },
  {
    title: "Inwestor",
    items: [
      {
        question: "Kiedy jest wymagany dziennik budowy?",
        answer: `Prowadzenie dziennika budowy jest obowiązkiem kierownika budowy. 
      W&nbsp;związku z&nbsp;tym, obowiązek posiadania dziennika budowy dotyczy robót budowlanych, przy których wymagane jest ustanowienie kierownika budowy.`
      }
    ]
  }
];
